import { useQuery } from '@tanstack/react-query';
import { fetchMe } from './api';

/** The single `['auth', 'me']` query every authenticated-vs-not decision in
 * the app reads from (AuthGuard, LoginRoute, the Header user menu). A 401
 * here is a normal "not logged in" outcome, not an error to surface — see
 * client.ts's isExemptFromHardRedirect for why this specific request never
 * triggers the hard-redirect interceptor. */
export function useSession() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchMe,
    retry: false,
    staleTime: 5 * 60_000,
  });
}
